import * as type from "../types";

export function organizationSearchRequest(value) {
  return {
    type: type.ORGANIZATION_SEARCH_REQUESTED,
    payload: value,
  };
}
export function organizationSearchSucceeded(data) {
  return {
    type: type.ORGANIZATION_SEARCH_SUCCEEDED,
    payload: data,
  };
}
export function organizationSearchFailed() {
  return {
    type: type.ORGANIZATION_SEARCH_FAILED,
  };
}
export function organizationFindByTermSearchRequest(values) {
  return {
    type: type.ORGANIZATION_FIND_BY_TERM_SEARCH_REQUESTED,
    payload: values,
  };
}
export function organizationFindByTermSearchSucceeded(data) {
  return {
    type: type.ORGANIZATION_FIND_BY_TERM_SEARCH_SUCCEEDED,
    payload: data,
  };
}
export function organizationFindByTermSearchFailed() {
  return {
    type: type.ORGANIZATION_FIND_BY_TERM_SEARCH_FAILED,
  };
}
export function organizationSelect(organization) {
  return {
    type: type.ORGANIZATION_SELECT,
    payload: organization,
  };
}

export function getOrganizationRequest(value) {
  return {
    type: type.GET_ORGANIZATION_REQUESTED,
    payload: value,
  };
}
export function getOrganizationSucceeded(data) {
  return {
    type: type.GET_ORGANIZATION_SUCCEEDED,
    payload: data,
  };
}
export function getOrganizationFailed() {
  return {
    type: type.GET_ORGANIZATION_FAILED,
  };
}
export function updateUserLimitsRequest(value) {
  return {
    type: type.UPDATE_USER_LIMITS_REQUEST,
    payload: value,
  };
}
export function updateUserLimitsFailed(err) {
  return {
    type: type.UPDATE_USER_LIMITS_FAILED,
    payload: err,
  };
}

export function updateUserLimitsSucceeded(data) {
  return {
    type: type.UPDATE_USER_LIMITS_SUCCEEDED,
    payload: data,
  };
}
export function updateOrganizationLimitsRequest(value) {
  return {
    type: type.UPDATE_ORGANIZATION_LIMITS_REQUEST,
    payload: value,
  };
}
export function updateOrganizationLimitsFailed(err) {
  return {
    type: type.UPDATE_ORGANIZATION_LIMITS_FAILED,
    payload: err,
  };
}

export function updateOrganizationLimitsSucceeded(data) {
  return {
    type: type.UPDATE_ORGANIZATION_LIMITS_SUCCEEDED,
    payload: data,
  };
}
export function getUserLimitsRequest(payload) {
  return {
    type: type.GET_USER_LIMITS_REQUEST,
    payload: payload,
  };
}
export function getUserLimitsSucceeded(data) {
  return {
    type: type.GET_USER_LIMITS_SUCCEEDED,
    payload: data,
  };
}
export function getUserLimitsFailed() {
  return {
    type: type.GET_USER_LIMITS_FAILED,
  };
}
export function getUsersLimitsRequest(payload) {
  return {
    type: type.GET_USERS_LIMITS_REQUEST,
    payload: payload,
  };
}
export function getUsersLimitsSucceeded(data) {
  return {
    type: type.GET_USERS_LIMITS_SUCCEEDED,
    payload: data,
  };
}
export function getUsersLimitsFailed() {
  return {
    type: type.GET_USERS_LIMITS_FAILED,
  };
}

export function getRegistrationGeneralStatusRequest(payload) {
  return {
    type: type.GET_REGISTRATION_GENERAL_STATUS_REQUESTED,
    payload,
  };
}

export function getRegistrationGeneralStatusSucceeded(data) {
  return {
    type: type.GET_REGISTRATION_GENERAL_STATUS_SUCCEEDED,
    payload: data,
  };
}

export function getRegistrationGeneralStatusFailed(err) {
  return {
    type: type.GET_REGISTRATION_GENERAL_STATUS_FAILED,
    payload: err,
  };
}

export function getRegistrationParticipantStatusRequest(payload) {
  return {
    type: type.GET_REGISTRATION_PARTICIPANT_STATUS_REQUESTED,
    payload: payload,
  };
}

export function getRegistrationParticipantStatusSucceeded(data) {
  return {
    type: type.GET_REGISTRATION_PARTICIPANT_STATUS_SUCCEEDED,
    payload: data,
  };
}

export function getRegistrationParticipantStatusFailed(err) {
  return {
    type: type.GET_REGISTRATION_PARTICIPANT_STATUS_FAILED,
    payload: err,
  };
}

// organization registration general commitment status
export function getRegistrationGeneralCommitmentStatusRequest(payload) {
  return {
    type: type.GET_REGISTRATION_GENERAL_COMMITMENT_STATUS_REQUESTED,
    payload,
  };
}
export function getRegistrationGeneralCommitmentStatusSucceeded(data) {
  return {
    type: type.GET_REGISTRATION_GENERAL_COMMITMENT_STATUS_SUCCEEDED,
    payload: data,
  };
}

export function getRegistrationGeneralCommitmentStatusFailed(err) {
  return {
    type: type.GET_REGISTRATION_GENERAL_COMMITMENT_STATUS_FAILED,
    payload: err,
  };
}

// organization registration commitment status

export function getRegistrationCommitmentStatusRequest(payload) {
  return {
    type: type.GET_REGISTRATION_COMMITMENT_STATUS_REQUESTED,
    payload,
  };
}
export function getRegistrationCommitmentStatusSucceeded(data) {
  return {
    type: type.GET_REGISTRATION_COMMITMENT_STATUS_SUCCEEDED,
    payload: data,
  };
}

export function getRegistrationCommitmentStatusFailed(err) {
  return {
    type: type.GET_REGISTRATION_COMMITMENT_STATUS_FAILED,
    payload: err,
  };
}
